import { render, staticRenderFns } from "./SelectableProducts.vue?vue&type=template&id=3cb68a20&"
import script from "./SelectableProducts.vue?vue&type=script&lang=ts&"
export * from "./SelectableProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports